import { useState, useEffect, cloneElement } from 'react';

export interface WizardProps {
  currentStep: number;
  stepProgress: number;
  size: number;
  data: any;
  setData: (data: any) => void;
  goToStep: (number: number) => void;
  nextStep: () => void;
  previousStep: () => void;
  resetSteps: () => void;
}

interface Props {
  start: number;
  initialData: any;
  children: JSX.Element[];
}

const Wizard = ({ start, initialData, children }: Props) => {
  const [currentStep, setCurrentStep] = useState(start);
  const [stepProgress, setStepProgress] = useState(start);
  const [size, setSize] = useState(0);
  const [data, setData] = useState(initialData);

  useEffect(() => {
    setSize(children.length);
  }, [children.length]);

  const goToStep = (number: number) => {
    setCurrentStep(number);
    setStepProgress(number);
  };

  const nextStep = () => {
    if (size === stepProgress + 1) return;
    goToStep(stepProgress + 1);
  };

  const previousStep = () => {
    if (stepProgress === 0) return;
    goToStep(stepProgress - 1);
  };

  const resetSteps = () => {
    setCurrentStep(start);
    setStepProgress(start);
  };

  const child = children[currentStep];

  return cloneElement(child, {
    ...child,
    key: currentStep,
    wizard: {
      currentStep,
      stepProgress,
      size,
      data,
      setData,
      goToStep,
      nextStep,
      previousStep,
      resetSteps,
    },
  });
};

Wizard.defaultProps = {
  start: 0,
  initialData: {},
};

export default Wizard;
